export default "__VITE_ASSET__DXRp2ibD__"